import { useEffect, useRef } from 'react'
import { CartApiError } from '../cartApi'

const asErrorMessage = (error: unknown) => {
  if (error instanceof CartApiError) return error.message
  if (error instanceof Error && error.message.trim()) return error.message
  return 'Errore gestione carrello'
}

export const useCartBootstrap = ({
  ensureCart,
  setInitializing,
  setError,
}: {
  ensureCart: () => Promise<unknown>
  setInitializing: (value: boolean) => void
  setError: (value: string) => void
}) => {
  const initDoneRef = useRef(false)

  useEffect(() => {
    if (initDoneRef.current) return
    initDoneRef.current = true

    let active = true
    setInitializing(true)
    setError('')

    const bootstrap = async () => {
      try {
        await ensureCart()
      } catch (error) {
        if (!active) return
        setError(asErrorMessage(error))
      } finally {
        if (active) {
          setInitializing(false)
        }
      }
    }

    void bootstrap()

    return () => {
      active = false
    }
  }, [ensureCart, setError, setInitializing])
}
